import {
  PAGE_BE_ACCOMMODATION,
  PAGE_BE_TRANSPORT,
  PAGE_BE_PARTICIPANTS,
  PAGE_BE_ACTIVITIES,
} from 'Utils/booking-engine-pages/BookingPagesUtils';

const BOOKING_STEPS = {
  PARTICIPANTS: {
    BE_LEGACY: 'payment/participants',
    BE_RESPONSIVE: PAGE_BE_PARTICIPANTS,
    CXO: 'book',
  },
  ACCOMMODATIONS: {
    BE_LEGACY: 'accommodations',
    BE_RESPONSIVE: PAGE_BE_ACCOMMODATION,
    CXO: 'configure',
  },
  ACTIVITIES: {
    BE_LEGACY: 'activities',
    BE_RESPONSIVE: PAGE_BE_ACTIVITIES,
    CXO: 'configure',
  },
  TRANSPORT: {
    BE_LEGACY: 'transport',
    BE_RESPONSIVE: PAGE_BE_TRANSPORT,
    CXO: 'configure',
  },
};

export { BOOKING_STEPS };
